export const SCANDPHOTOS_NEW_ORDER_SUCCESS = 'SCANDPHOTOS_NEW_ORDER_SUCCESS';
export const SCANDPHOTOS_NEW_ORDER_FIRM_DETAILS_SUCCESS =
    'SCANDPHOTOS_NEW_ORDER_FIRM_DETAILS_SUCCESS';
export const SCANDPHOTOS_CREATE_ORDER_SUCCESS = 'SCANDPHOTOS_CREATE_ORDER_SUCCESS';
export const SCANDPHOTOS_GET_ORDERS_SUCCESS = 'SCANDPHOTOS_GET_ORDERS_SUCCESS';
